/* Profile pill — the Targeting 360 header treatment: avatar, two stacked
   lines, chevron; same height and border language as the date-range pill so
   the right-hand cluster reads as one row of controls. */
.pill {
  display: flex;
  align-items: center;
  gap: 8px;
  height: var(--control-h, 40px);
  padding: 0 12px;
  border: 1px solid var(--header-border, #e0e0e0);
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  max-width: 240px;
}
.pill:hover:not(:disabled) { border-color: #c9ccd4; }
.pill:disabled { opacity: 0.55; cursor: default; }

.avatar {
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  border-radius: 50%;
  background: linear-gradient(135deg, #4f46e5, #7c5cff);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.text { display: flex; flex-direction: column; align-items: flex-start; min-width: 0; }
.name {
  font-size: 13px;
  font-weight: 600;
  color: var(--header-text, #333843);
  line-height: 16px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.role { font-size: 11px; color: var(--header-text-muted, #8f8f91); line-height: 14px; }
.chevron { width: 16px; height: 16px; flex-shrink: 0; opacity: 0.6; }

/* ---- panel ------------------------------------------------------------- */
.panel {
  width: 288px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 12px 32px rgba(16, 18, 27, 0.16);
  overflow: hidden;
}
.searchWrap { padding: 10px 10px 6px; }
.search {
  width: 100%;
  height: 34px;
  padding: 0 10px;
  border: 1px solid var(--border-control, #e3e5ea);
  border-radius: 7px;
  font-size: 13px;
  outline: none;
}
.search:focus { border-color: #7c5cff; }
.count {
  margin: 0;
  padding: 2px 12px 6px;
  font-size: 11px;
  color: var(--text-muted, #7a7f8a);
}

/* Capped and scrolled: 32 grants is a list, not a menu. */
.list { max-height: 320px; overflow-y: auto; padding-bottom: 6px; }
.empty { margin: 0; padding: 14px 12px; font-size: 12px; color: var(--text-muted, #7a7f8a); }

.option {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  padding: 7px 12px;
  border: 0;
  background: none;
  cursor: pointer;
  text-align: left;
}
.option:hover { background: #f5f6f9; }
.option.on { background: #f1efff; }

.optionAvatar {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #eceef3;
  color: #4a4f5c;
  font-size: 9px;
  font-weight: 700;
}
.option.on .optionAvatar { background: linear-gradient(135deg, #4f46e5, #7c5cff); color: #fff; }
.optionText { display: flex; flex-direction: column; min-width: 0; flex: 1; }
.optionName {
  font-size: 13px;
  color: var(--text-primary, #1c1e23);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.optionRole { font-size: 11px; color: var(--text-muted, #7a7f8a); }
.tick { color: #7c5cff; font-size: 13px; flex-shrink: 0; }
